export default __webpack_public_path__ + "static/media/misc-drawerB-1024w.c7b292e5.webp";